import request from '~/utils/request';

import { getUserData } from '~/redux/actions/auth-actions';
import { failure, success } from '~/redux/actions/snackbar-actions';
import {
  SET_DESIGNER_CREDIT_PACKAGES,
  SET_DESIGNER_CREDIT_PACKAGES_LOADER,
  SET_DESIGNER_HISTORY_DATA,
  SET_DESIGNER_HISTORY_LOADER,
} from './action-types';

const fetchDesignerCreditPackages = () => async (dispatch) => {
  try {
    dispatch({ type: SET_DESIGNER_CREDIT_PACKAGES_LOADER, payload: true });
    const response = await request.get('custom-template-queries/credit-packages');

    if (response.status === 200) {
      dispatch({
        type: SET_DESIGNER_CREDIT_PACKAGES,
        payload: response?.data?.data || [],
      });
    }

    return response;
  } catch (error) {
    return error.response || error;
  } finally {
    dispatch({ type: SET_DESIGNER_CREDIT_PACKAGES_LOADER, payload: false });
  }
};

const buyDesignerCredits = (packageId) => async (dispatch) => {
  try {
    const response = await request.post('custom-template-queries/buy-credits', { id: packageId });
    const purchase = response?.data?.data;

    if (response.status === 200 && purchase?.success) {
      dispatch(success(response?.data?.message || 'Designer credits purchased successfully'));
      await dispatch(getUserData());
    } else {
      dispatch(failure(response?.data?.message || 'Designer credits purchase failed'));
    }

    return response;
  } catch (error) {
    dispatch(failure(error?.response?.data?.message || 'Designer credits purchase failed'));
    return error.response || error;
  }
};

const fetchDesignerHistory =
  ({ page = 1, perPage = 5, orgId } = {}) =>
  async (dispatch) => {
    try {
      dispatch({ type: SET_DESIGNER_HISTORY_LOADER, payload: true });
      const response = await request.get('custom-template-queries/history', {
        page,
        pageSize: perPage,
        orgId,
      });

      if (response.status === 200) {
        dispatch({
          type: SET_DESIGNER_HISTORY_DATA,
          payload: response?.data?.data || {},
        });
      }

      return response;
    } catch (error) {
      return error.response || error;
    } finally {
      dispatch({ type: SET_DESIGNER_HISTORY_LOADER, payload: false });
    }
  };

const createDesignerRequest =
  (formData, historyPage = 1, historyPerPage = 5) =>
  async (dispatch) => {
    try {
      const response = await request.post('custom-template-queries', formData);

      if (response.status === 200) {
        dispatch(success(response?.data?.message || 'Design request submitted successfully'));
        await dispatch(getUserData());
        await dispatch(fetchDesignerHistory({ page: historyPage, perPage: historyPerPage }));
      }

      return response;
    } catch (error) {
      dispatch(failure(error?.response?.data?.message || 'Design request submission failed'));
      return error.response || error;
    }
  };

const fetchDesignerQueryDetails = async (id) => {
  try {
    return await request.get(`custom-template-queries/${id}`);
  } catch (error) {
    return error.response || error;
  }
};

const fetchDesignerQueryTemplateDetails = async (id) => {
  try {
    return await request.get(`custom-template-queries/${id}/template-details`);
  } catch (error) {
    return error.response || error;
  }
};

export {
  fetchDesignerCreditPackages,
  buyDesignerCredits,
  fetchDesignerHistory,
  createDesignerRequest,
  fetchDesignerQueryDetails,
  fetchDesignerQueryTemplateDetails,
};
